module.exports = {"620423100":"一条山镇","620423101":"芦阳镇","620423102":"上沙沃镇","620423103":"喜泉镇","620423104":"草窝滩镇","620423105":"红水镇","620423106":"中泉镇","620423107":"正路镇","620423203":"寺滩乡","620423205":"五佛乡","620423207":"漫水滩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620423.json
// module id = 3045
// module chunks = 0